import api from './api';

const createTag = payload => {
  return api.post('/api/wo-tag', payload);
};

const getAllTags = () => {
  return api.get('/api/wo-tag');
};

const searchTags = keyword => {
  return api.get('/api/wo-tag/search', {
    params: { keyword: keyword || '' },
  });
};

const getTagById = id => {
  return api.get(`/api/wo-tag/${id}`);
};

const updateTag = (id, payload) => {
  return api.patch(`/api/wo-tag/${id}`, payload);
};

const deleteTag = id => {
  return api.delete(`/api/wo-tag/${id}`);
};

const TagService = {
  createTag,
  getAllTags,
  searchTags,
  getTagById,
  updateTag,
  deleteTag,
};

export default TagService;
